module.exports = __webpack_public_path__ + "img/1F6B1.608187d0.svg";